import React from 'react';
import { Link } from 'react-router-dom';
export function Terms() {
  return <div className="max-w-3xl mx-auto px-6 pt-32 pb-24" data-id="element-12875" data-mp="3tp0mg01wleqe">
      <h1 className="text-4xl font-bold text-[#2B211A] mb-8 font-title tracking-tight" data-id="element-12876" data-mp="3tpk4dgrk034f">
        Terms of Service
      </h1>

      <div className="space-y-10 text-neutral-700 font-body leading-relaxed text-[17px]" data-id="element-12877" data-mp="2gmulhnx2gta">
        <section data-id="element-12878" data-mp="7biwd9iygijl">
          <h2 className="text-2xl font-semibold text-[#2B211A] mb-4 font-title tracking-tight" data-id="element-12879" data-mp="c8j2tljpvnb8">
            1. Acceptance of Terms
          </h2>
          <p data-id="element-12880" data-mp="g9314sg10wyy">
            By accessing or using Giga ("Service"), you agree to be bound by
            these Terms of Service. If you disagree with any part of the terms,
            you may not access the Service. These terms apply to all visitors,
            users, and others who access or use the Service.
          </p>
        </section>

        <section data-id="element-12881" data-mp="2n2wzt7dptlry">
          <h2 className="text-2xl font-semibold text-[#2B211A] mb-4 font-title tracking-tight" data-id="element-12882" data-mp="2rzf1tzhnv60l">
            2. Account Terms
          </h2>
          <ul className="list-disc pl-5 space-y-2" data-id="element-12883" data-mp="23a4qlbwgwfka">
            <li data-id="element-12884" data-mp="1yimp8mqj8cys">You must be 18 years or older to use this Service.</li>
            <li data-id="element-12885" data-mp="1yhbhycxvon2x">
              You must provide your legal full name, a valid email address, and
              any other information requested in order to complete the signup
              process.
            </li>
            <li data-id="element-12886" data-mp="1pg52m76ytib9">
              You are responsible for maintaining the security of your account
              and password. Giga cannot and will not be liable for any loss or
              damage from your failure to comply with this security obligation.
            </li>
            <li data-id="element-12887" data-mp="2d5zd4i3tausc">
              You are responsible for all content posted and activity that
              occurs under your account.
            </li>
          </ul>
        </section>

        <section data-id="element-12888" data-mp="11t59tg1qzcjw">
          <h2 className="text-2xl font-semibold text-[#2B211A] mb-4 font-title tracking-tight" data-id="element-12889" data-mp="11tosx034w6zi">
            3. API Usage
          </h2>
          <p className="mb-4" data-id="element-12890" data-mp="yag6xgzpfttn">
            Customers may access their Giga account data via an API (Application
            Program Interface). Any use of the API, including use of the API
            through a third-party product that accesses Giga, is bound by these
            Terms of Service plus the following specific terms:
          </p>
          <ul className="list-disc pl-5 space-y-2" data-id="element-12891" data-mp="ta1xpvmdadu1">
            <li data-id="element-12892" data-mp="fjyg5hyfn8ax">
              You expressly understand and agree that Giga shall not be liable
              for any direct, indirect, incidental, special, consequential or
              exemplary damages, including but not limited to, damages for loss
              of profits, goodwill, use, data or other intangible losses
              resulting from your use of the API.
            </li>
            <li data-id="element-12893" data-mp="3sqi2tc90kqnq">
              Abuse or excessively frequent requests to Giga via the API may
              result in the temporary or permanent suspension of your account's
              access to the API.
            </li>
          </ul>
        </section>

        <section data-id="element-12894" data-mp="3e4bbn5ep8i5m">
          <h2 className="text-2xl font-semibold text-[#2B211A] mb-4 font-title tracking-tight" data-id="element-12895" data-mp="3e5vu3wnqoan4">
            4. Data and Privacy
          </h2>
          <p data-id="element-12896" data-mp="3n4zfj7adp24s">
            Your use of the Service is also governed by our Privacy Policy. Giga
            claims no intellectual property rights over the material you provide
            to the Service. Your profile and materials uploaded remain yours.
          </p>
        </section>

        <section data-id="element-12897" data-mp="3s3u6iwii1wzz">
          <h2 className="text-2xl font-semibold text-[#2B211A] mb-4 font-title tracking-tight" data-id="element-12898" data-mp="3s4cdan2sftm5">
            4.5 User Data Deletion
          </h2>
          <p data-id="element-12899" data-mp="am9pdr8hj4vx">
            You may delete your account at any time. Upon deletion, we will
            remove or anonymise your data within 30 days. You may also request
            deletion of specific integration data by contacting us at{' '}
            <a href="mailto:support@getgiga.com" className="text-[#EA580C] hover:underline font-medium" data-id="element-12900" data-mp="ep68rk5un50x">
              support@getgiga.com
            </a>
            . We comply with data deletion requests as required by applicable
            law and the Google API Services User Data Policy.
          </p>
        </section>

        {/*
         * SMS & TEXT MESSAGING.
         *
         * Required for US A2P 10DLC messaging registration: a reviewer opens
         * this page and checks that the public terms describe the texting
         * being registered — consent, STOP to opt out, HELP for help, that
         * frequency varies and rates may apply, and that the named legal
         * entity matches the registration. The consent checkboxes on the
         * enquiry form already carry this language; a mismatch between the
         * form and these pages is a common rejection reason, so the two must
         * be changed together.
         *
         * Placed beside Data and Privacy rather than at the end: it is a
         * communications and data topic, and it needs to be findable.
         */}
        <section data-id="element-12901" data-mp="3pnu41u9lga6h">
          <h2 className="text-2xl font-semibold text-[#2B211A] mb-4 font-title tracking-tight" data-id="element-12902" data-mp="3podn5eazd4m3">
            4.6 SMS &amp; Text Messaging
          </h2>
          <p className="mb-4" data-id="element-12903" data-mp="3fyu345bj74pn">
            By providing your phone number and opting in, you consent to receive
            automated and/or recurring text (SMS) messages from Giga, operated
            by Tonic Labs Limited, at the number you provide. These may include
            messages about your enquiry or demo (such as confirmations,
            reminders and follow-ups) and, if you opt in to them, promotional or
            marketing messages.
          </p>
          <ul className="list-disc pl-5 space-y-2" data-id="element-12904" data-mp="2x2aqv75fl0ov">
            <li data-id="element-12905" data-mp="2szealn3d5go3">
              Consent to receive promotional messages is not a condition of
              using our service.
            </li>
            <li data-id="element-12906" data-mp="v6qvxr7j8kt3">
              Message frequency varies. Message and data rates may apply — your
              mobile carrier may charge you for messages you receive.
            </li>
            <li data-id="element-12907" data-mp="2kofhe6wamvv1">
              You can opt out of SMS at any time by replying{' '}
              <strong className="text-[#2B211A]" data-id="element-12908" data-mp="2phgxujc5f3gq">STOP</strong> to any message.
              For help, reply <strong className="text-[#2B211A]" data-id="element-12909" data-mp="2bqbsd0m3ngyh">HELP</strong>.
            </li>
            <li data-id="element-12910" data-mp="2fqdwrhj7yohg">
              We honour opt-out requests promptly. Opting out of promotional
              messages does not affect service-related messages we are permitted
              to send you.
            </li>
            <li data-id="element-12911" data-mp="38ei4e8lcpbms">
              We do not sell your phone number. Our handling of personal data is
              described in our{' '}
              <Link to="/privacy" className="text-[#EA580C] hover:underline font-medium" data-id="element-12912" data-mp="2uhw9n6gs82wl">
                Privacy Policy
              </Link>
              .
            </li>
          </ul>
        </section>

        <section data-id="element-12913" data-mp="1j2zhvot7qzlj">
          <h2 className="text-2xl font-semibold text-[#2B211A] mb-4 font-title tracking-tight" data-id="element-12914" data-mp="1nzg58gsl99xk">
            5. Termination
          </h2>
          <p data-id="element-12915" data-mp="1fhnu6of9r4v4">
            We may terminate or suspend access to our Service immediately,
            without prior notice or liability, for any reason whatsoever,
            including without limitation if you breach the Terms. All provisions
            of the Terms which by their nature should survive termination shall
            survive termination, including, without limitation, ownership
            provisions, warranty disclaimers, indemnity and limitations of
            liability.
          </p>
        </section>

        <section data-id="element-12916" data-mp="ruxuvuub1oe7">
          <h2 className="text-2xl font-semibold text-[#2B211A] mb-4 font-title tracking-tight" data-id="element-12917" data-mp="rra618zt1q5t">
            5.5 Acceptable Use
          </h2>
          <p data-id="element-12918" data-mp="11q9eorkkllst">
            You agree not to use the Service for any unlawful purpose or in
            violation of any applicable laws or regulations. You may not use
            the Service to transmit malware, spam, or content that infringes
            third-party rights. We reserve the right to suspend or terminate
            accounts engaged in prohibited use.
          </p>
        </section>

        <section data-id="element-12919" data-mp="3ooua48494yvm">
          <h2 className="text-2xl font-semibold text-[#2B211A] mb-4 font-title tracking-tight" data-id="element-12920" data-mp="3oob1xj4elous">
            6. Limitation of Liability
          </h2>
          <p data-id="element-12921" data-mp="2gb7loue6ihg">
            In no event shall Giga, nor its directors, employees, partners,
            agents, suppliers, or affiliates, be liable for any indirect,
            incidental, special, consequential or punitive damages, including
            without limitation, loss of profits, data, use, goodwill, or other
            intangible losses, resulting from your access to or use of or
            inability to access or use the Service.
          </p>
        </section>

        <section data-id="element-12922" data-mp="l8ww1o2yz6s0">
          <h2 className="text-2xl font-semibold text-[#2B211A] mb-4 font-title tracking-tight" data-id="element-12923" data-mp="q6fatv3o4g7x">
            7. Governing Law
          </h2>
          <p data-id="element-12924" data-mp="u8k2ioak32rx">
            These Terms shall be governed by and construed in accordance with
            the laws of Ireland. Any disputes arising under these Terms shall
            be subject to the exclusive jurisdiction of the courts of Ireland.
          </p>
        </section>

        <section data-id="element-12925" data-mp="25obke17wyo9h">
          <h2 className="text-2xl font-semibold text-[#2B211A] mb-4 font-title tracking-tight" data-id="element-12926" data-mp="25pwdrnihs15r">
            8. Service Availability
          </h2>
          <p data-id="element-12927" data-mp="2ydsh3b2kgrbi">
            We strive for high availability but do not guarantee uninterrupted
            access. We reserve the right to perform maintenance, updates, or
            suspend access as needed with reasonable notice where practicable.
          </p>
        </section>

        <section data-id="element-12928" data-mp="2olw6j0jan8qe">
          <h2 className="text-2xl font-semibold text-[#2B211A] mb-4 font-title tracking-tight" data-id="element-12929" data-mp="2jow0uqqcw7zt">
            9. Third-Party Services
          </h2>
          <p data-id="element-12930" data-mp="3h51s5orzjo57">
            Giga connects to third-party services you authorise via OAuth. We
            are not responsible for the availability, security, or data
            practices of those services. Your use of connected third-party
            services remains subject to their terms and privacy policies.
          </p>
        </section>

        {/*
         * WHO THESE TERMS ARE WITH. The page governed by Irish law but never
         * named the entity, so a messaging or payments reviewer could not match
         * it against the registration. The registered address is deliberately
         * NOT invented here — add the real one from the CRO filing.
         */}
        <section data-id="element-12931" data-mp="2kvbhjwwozr7u">
          <h2 className="text-2xl font-semibold text-[#2B211A] mb-4 font-title tracking-tight" data-id="element-12932" data-mp="2ktryxznkd42w">
            10. Operator and Contact
          </h2>
          <p data-id="element-12933" data-mp="2ukcutfburui4">
            Giga is operated by{' '}
            <strong className="text-[#2B211A]" data-id="element-12934" data-mp="2ulnx1apngu74">Tonic Labs Limited</strong>, a
            company registered in Ireland. Questions about these Terms, or
            about messages you receive from us, can be sent to{' '}
            <a href="mailto:support@getgiga.com" className="text-[#EA580C] hover:underline font-medium" data-id="element-12935" data-mp="34kdi1ccueurl">
              support@getgiga.com
            </a>
            .
          </p>
        </section>

        <section className="pt-8 border-t border-neutral-200/60" data-id="element-12936" data-mp="3s54mg4ty8kqj">
          <p className="text-sm text-neutral-500" data-id="element-12937" data-mp="3e53de23j66zz">Last updated: September 2026</p>
        </section>
      </div>
    </div>;
}